import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { login } from "../../store/reducers/authReducer";
import { CFV } from "../common/others/Functions";
import OpacityLoading from "../common/loader/OpacityLoading";
import bsLogo from "../../assets/common/comps/wd.png";

const DEFAULT_UNAUTH_STORAGE_KEY = "defaultUnAuthRoute";

const MainUnAuthWD = () => {
  const dispatch = useDispatch();
  const { todosLoading } = useSelector((state) => state.todosReducer);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem(DEFAULT_UNAUTH_STORAGE_KEY, "mainWD");
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const body = { ...data };
    dispatch(login(body)).then((res) => {
      setIsLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <div style={styles.container}>
      {/* Background gradient overlay */}
      <div style={styles.gradientOverlay} />

      {/* Content */}
      <div style={styles.content}>
        {/* Logo Section */}
        <div style={styles.logoSection}>
          <img src={bsLogo} alt="Be Simple Events" style={styles.logo} />
        </div>

        {/* Login Card */}
        <div style={styles.loginCard}>
          <h3 style={styles.loginTitle}>התחברות למערכת</h3>

          <form onSubmit={handleSubmit(onSubmit)} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>מספר נייד</label>
              <input
                style={styles.input}
                placeholder="050XXXXXXX"
                {...register("phone", {
                  required: true,
                  pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
                })}
              />
              {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>סיסמא</label>
              <input
                style={styles.input}
                type="password"
                placeholder="הזן סיסמא"
                {...register("password", {
                  required: true,
                  minLength: 2,
                  maxLength: 20,
                })}
              />
              {CFV("password", "בין 2 ל 20 תווים", errors)}
            </div>

            <button type="submit" style={styles.submitButton}>
              כניסה למערכת
            </button>
          </form>
        </div>

        {/* Footer */}
        <p style={styles.footer}>© Wedding Planner 2017</p>
      </div>

      {(todosLoading || isLoading) && <OpacityLoading />}
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    // background: "#ffffff",
    background: "linear-gradient( #ffffff,#ffffff,#5c5a5a,#3a3a3a)",
  },
  gradientOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
  },
  content: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    minHeight: "100vh",
    padding: "24px 16px",
    width: "100%",
    maxWidth: "360px",
  },
  logoSection: {
    textAlign: "center",
  },
  logo: {
    width: "320px",
    height: "auto",
    marginBottom: "0",
    filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.08))",
  },
  tagline: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "10px",
    textShadow: "0 2px 10px rgba(0,0,0,0.3)",
    fontFamily: "'Heebo', sans-serif",
  },
  subtitle: {
    color: "rgba(255,255,255,0.8)",
    fontSize: "16px",
    fontWeight: "400",
    fontFamily: "'Heebo', sans-serif",
  },
  loginCard: {
    background: "#f2f2f2",
    borderRadius: "16px",
    padding: "16px 18px",
    width: "100%",
    boxShadow: "0 4px 24px rgba(117, 85, 27, 0.3)",
  },
  loginTitle: {
    color: "#4f380e",
    fontSize: "18px",
    fontWeight: "600",
    textAlign: "center",
    marginBottom: "12px",
    fontFamily: "'Heebo', sans-serif",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  label: {
    color: "#4f380e",
    fontSize: "13px",
    fontWeight: "500",
    fontFamily: "'Heebo', sans-serif",
  },
  input: {
    background: "rgba(255, 255, 255, 0.95)",
    border: "1px solid rgba(255, 255, 255, 0.5)",
    borderRadius: "10px",
    padding: "10px 14px",
    fontSize: "15px",
    color: "#333",
    outline: "none",
    transition: "all 0.2s ease",
    fontFamily: "'Heebo', sans-serif",
    direction: "rtl",
  },
  submitButton: {
    background: "#75551B",
    border: "none",
    borderRadius: "10px",
    padding: "10px",
    fontSize: "15px",
    fontWeight: "600",
    color: "#ffffff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginTop: "4px",
    fontFamily: "'Heebo', sans-serif",
    boxShadow: "0 2px 12px rgba(117, 85, 27, 0.4)",
  },
  footer: {
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "'Heebo', sans-serif",
  },
};

export default MainUnAuthWD;
